<template>
    <b-container fluid>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ (currentLocale === 'bn') ? 'চাইল্ড সার্ভিস ড্যাশবোর্ড' : 'Child Service Dashboard' }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay>
                            <b-row class="mb-4">
                                <b-col md="11" lg="11" xl="11" sm="12" style="margin: auto">
                                    <b-row>
                                        <b-col v-if="search.office_id === 0" xs="12" sm="12" md="4" lg="4" xl="4" class="mt-4">
                                            <b-button block type="button" class="pt-3 pb-3 child_dsb_card">
                                                <div>
                                                    <b-spinner v-if="unitLoad" variant="light" label="Spinning"></b-spinner>
                                                    <div v-else class="h2 text-bold" style="font-weight: bold">{{ $n(officeList.length) }}</div>
                                                </div>
                                                <div class="h6">{{ $t('institute_manangement.total_institute') }}</div>
                                            </b-button>
                                        </b-col>
                                        <b-col xs="12" sm="12" md="4" lg="4" xl="4" class="mt-4">
                                            <b-button block type="button" class="pt-3 pb-3 child_dsb_card">
                                                <div>
                                                    <b-spinner v-if="unitLoad" variant="light" label="Spinning"></b-spinner>
                                                    <div v-else class="h2 text-bold" style="font-weight: bold">{{ $n(informationData.totalApplicant) }}</div>
                                                </div>
                                                <div class="h6">{{ $t('institute_manangement.total_applicant') }}</div>
                                            </b-button>
                                        </b-col>
                                        <b-col xs="12" sm="12" md="4" lg="4" xl="4" class="mt-4">
                                            <b-button block type="button" class="pt-3 pb-3 child_dsb_card">
                                                <div>
                                                    <b-spinner v-if="unitLoad" variant="light" label="Spinning"></b-spinner>
                                                    <div v-else class="h2 text-bold" style="font-weight: bold">{{ $n(informationData.totalStudent) }}</div>
                                                </div>
                                                <div class="h6">{{ $t('institute_manangement.total_student') }}</div>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col xs="12" sm="12" md="4" lg="4" xl="4" class="mt-4">
                                            <b-button block type="button" class="pt-3 pb-3 child_dsb_card">
                                                <div>
                                                    <b-spinner v-if="unitLoad" variant="light" label="Spinning"></b-spinner>
                                                    <div v-else class="h2 text-bold" style="font-weight: bold">{{ $n(informationData.totalResident) }}</div>
                                                </div>
                                                <div class="h6">{{ $t('institute_manangement.total_resident') }}</div>
                                            </b-button>
                                        </b-col>
                                        <b-col xs="12" sm="12" md="4" lg="4" xl="4" class="mt-4">
                                            <b-button block type="button" class="pt-3 pb-3 child_dsb_card">
                                                <div>
                                                    <b-spinner v-if="unitLoad" variant="light" label="Spinning"></b-spinner>
                                                    <div v-else class="h2 text-bold" style="font-weight: bold">{{ $n(informationData.totalBoy) }}</div>
                                                </div>
                                                <div class="h6">{{ $t('institute_manangement.total_boy') }}</div>
                                            </b-button>
                                        </b-col>
                                        <b-col xs="12" sm="12" md="4" lg="4" xl="4" class="mt-4">
                                            <b-button block type="button" class="pt-3 pb-3 child_dsb_card">
                                                <div>
                                                    <b-spinner v-if="unitLoad" variant="light" label="Spinning"></b-spinner>
                                                    <div v-else class="h2 text-bold" style="font-weight: bold">{{ $n(informationData.totalGirl) }}</div>
                                                </div>
                                                <div class="h6">{{ $t('institute_manangement.total_girl') }}</div>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>

import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {},
  data () {
    return {
      unitLoad: false,
      search: {
        overall_dashboard: 1,
        org_id: 0,
        office_type_id: 0,
        office_id: 0
      },
    // totalInstitute: 0,
      informationData: {},
      officeList: []
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
      '$store.state.commonObj.organizationProfileList': function (newVal, oldVal) {
          if (newVal !== oldVal) {
            this.countTotalOffice()
          }
      }
  },
  created () {
    this.search.org_id = this.$store.state.dataFilters.orgId
    this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
    this.search.office_id = this.$store.state.dataFilters.officeId
    this.loadData()
    this.countTotalOffice()
  },
  mounted () {
  },
  methods: {
    countTotalOffice () {
        if (this.search.office_id === 0) {
            this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0).map(obj => {
                this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === obj.value).map(obj2 => {
                const oList = this.$store.state.commonObj.officeList.filter(itm => itm.status === 0 && obj2.value === itm.org_id)
                this.officeList.push(oList)
                })
            })
        }
    },
    loadData () {
      this.unitLoad = true
      const params = Object.assign({}, this.search)
      // this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(childServiceBaseUrl, 'institute-management/information-dashboard/list', params).then(response => {
          if (response.success) {
            this.informationData = response.data
            this.unitLoad = false
          }
          // this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    }
  }
}
</script>
<style>
    .child_dsb_card{
        color: #fff;
        border: none;
        box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
        background: linear-gradient(to bottom, #6db3f2 0%,#54a3ee 58%,#54a3ee 58%,#3690f0 58%,#1e69de 100%);
}
</style>
